export default __webpack_public_path__ + "static/media/pvilla6-4.485838b2.webp";